module.exports = __webpack_public_path__ + "img/p5.b2b2719.png";